function capitalize (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
}

function niceFieldType (type) {
  switch (type) {
    case 'select':
      return 'Dropdown'
      break;
    default:
      return capitalize(type)
  } 
}

function decimalToPercent (value) {
  return Math.round(value * 100) + '%'
}

function twoPointPercent(value) {
  return (parseFloat(value)*100).toFixed(1) + '%'
}

export default {
  filters: {
    capitalize,
    decimalToPercent,
    twoPointPercent,
    niceFieldType
  },
  methods: {
    capitalize: capitalize
  }
}